export const convertToEmptyString = (values) => {
  for (let i in values) {
    if (values[i] === null || values[i] === undefined) values[i] = "";
  }
  return values;
};
